
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useCreateGym = () => {
  const queryClient = useQueryClient();

  const createNewGym = async (name: string, address: string, logoFile: File | null = null) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("No user found");

      console.log("Creating new gym:", { name, address });
      
      // Crear el gimnasio
      const { data: gym, error: gymError } = await supabase
        .from("gyms")
        .insert({ name, address })
        .select()
        .single();

      if (gymError) {
        console.error("Error creating gym:", gymError);
        throw gymError;
      }

      // Si hay logo, subirlo
      if (logoFile && gym) {
        const fileExt = logoFile.name.split('.').pop();
        const fileName = `gym-logos/${gym.id}-${Date.now()}.${fileExt}`;

        const { error: uploadError } = await supabase.storage
          .from("images")
          .upload(fileName, logoFile);

        if (uploadError) {
          console.error("Error uploading logo:", uploadError);
        } else {
          const { data: { publicUrl } } = supabase.storage
            .from("images")
            .getPublicUrl(fileName);

          await supabase
            .from("gyms")
            .update({ logo_url: publicUrl })
            .eq("id", gym.id);
        }
      }

      console.log("Gym created successfully:", gym);
      console.log("Gym manager relationship will be handled automatically by database trigger");

      await queryClient.invalidateQueries({ queryKey: ["managerGyms"] });
      toast({
        title: "Gimnasio creado",
        description: "El gimnasio ha sido creado correctamente.",
      });
      return true;
    } catch (error: any) {
      console.error("Error in createNewGym:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "No se pudo crear el gimnasio.",
      });
      return false;
    }
  };

  return { createNewGym };
};
